'use strict';

namespace Search {

    export class SearchOccupancy {
        Adults: number = 2;
        ChildAges: number[] = [];
    }

    export class OccupancyConfig {
        MaxRooms: number;
        MaxAdults: number;
        MaxChildren: number;
        MaxChildAge: number;
        MaxAdultsInAdditionalRooms: number;
        MaxChildrenInAdditionalRooms: number;
    }

    export class DateRange {
        start: string;
        end: string;
    }

    export interface Airline {
        Title: string;
        Code: string;
        IsPostfilter: boolean | undefined;
    }

    export class Cabin {
        public name;
        constructor(
            public resource: string,
            public value: number | undefined,
            public queryStringCode: string | undefined,
            private resourceService: Core.ResourceService
        ) {
            this.name = this.resourceService.getDeferred(resource);
        }
    }

}
